// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-card-content {
  margin-top: 8px;
}

.image-container {
  height: 56px;
  margin-right: 24px;
  width: 72px;
}

/* stylelint-disable-next-line selector-pseudo-element-no-unknown */
.no-image ::ng-deep svg {
  height: 56px;
  margin-right: 24px;
  width: 72px;
}

.url-file {
  filter: grayscale(100%);
  opacity: 0.2;
}

.select {
  margin-right: 16px;
}

.image-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 40%;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImljb24tcGlja2VyLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsZUFBQTtBQUNGOztBQUVBO0VBQ0UsWUFBQTtFQUNBLGtCQUFBO0VBQ0EsV0FBQTtBQUNGOztBQUVBLG1FQUFBO0FBQ0E7RUFDRSxZQUFBO0VBQ0Esa0JBQUE7RUFDQSxXQUFBO0FBQ0Y7O0FBRUE7RUFDRSx1QkFBQTtFQUNBLFlBQUE7QUFDRjs7QUFFQTtFQUNFLGtCQUFBO0FBQ0Y7O0FBRUE7RUFDRSxnQkFBQTtFQUNBLHVCQUFBO0VBQ0EsbUJBQUE7RUFDQSxVQUFBO0FBQ0YiLCJmaWxlIjoiaWNvbi1waWNrZXIuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyJtYXQtY2FyZC1jb250ZW50IHtcbiAgbWFyZ2luLXRvcDogOHB4O1xufVxuXG4uaW1hZ2UtY29udGFpbmVyIHtcbiAgaGVpZ2h0OiA1NnB4O1xuICBtYXJnaW4tcmlnaHQ6IDI0cHg7XG4gIHdpZHRoOiA3MnB4O1xufVxuXG4vKiBzdHlsZWxpbnQtZGlzYWJsZS1uZXh0LWxpbmUgc2VsZWN0b3ItcHNldWRvLWVsZW1lbnQtbm8tdW5rbm93biAqL1xuLm5vLWltYWdlIDo6bmctZGVlcCBzdmcge1xuICBoZWlnaHQ6IDU2cHg7XG4gIG1hcmdpbi1yaWdodDogMjRweDtcbiAgd2lkdGg6IDcycHg7XG59XG5cbi51cmwtZmlsZSB7XG4gIGZpbHRlcjogZ3JheXNjYWxlKDEwMCUpO1xuICBvcGFjaXR5OiAwLjI7XG59XG5cbi5zZWxlY3Qge1xuICBtYXJnaW4tcmlnaHQ6IDE2cHg7XG59XG5cbi5pbWFnZS1uYW1lIHtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgdGV4dC1vdmVyZmxvdzogZWxsaXBzaXM7XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gIHdpZHRoOiA0MCU7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./libs/shared/ng/common/src/lib/components/icon-picker/icon-picker.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,YAAA;EACA,kBAAA;EACA,WAAA;AACF;;AAEA,mEAAA;AACA;EACE,YAAA;EACA,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,uBAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AACF;AACA,oqCAAoqC","sourcesContent":["mat-card-content {\n  margin-top: 8px;\n}\n\n.image-container {\n  height: 56px;\n  margin-right: 24px;\n  width: 72px;\n}\n\n/* stylelint-disable-next-line selector-pseudo-element-no-unknown */\n.no-image ::ng-deep svg {\n  height: 56px;\n  margin-right: 24px;\n  width: 72px;\n}\n\n.url-file {\n  filter: grayscale(100%);\n  opacity: 0.2;\n}\n\n.select {\n  margin-right: 16px;\n}\n\n.image-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 40%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
